import React from 'react';
import { Avatar } from 'antd';

const SbAvatar = (props) => <Avatar {...props} />;

export default SbAvatar;
